export default [
  {
    path: "/home",
    component: () => import("@/pages/home"),
    meta: {
      isActive: true,
      title: "首页",
    },
  },
  {
    path: "/associationProfile",
    component: () => import("@/pages/associationProfile"),
  },
  {
    path: "/organizational",
    component: () => import("@/pages/organizational"),
  },
  {
    path: "/certificate",
    component: () => import("@/pages/certificate"),
  },
  {
    path: "/contact",
    component: () => import("@/pages/contact"),
  },
  {
    path: "/news",
    component: () => import("@/pages/news"),
  },
  {
    path: "/news/20250903",
    component: () => import("@/pages/news/details/20250903.vue"),
  },
  {
    path: "/news/20250806",
    component: () => import("@/pages/news/details/20250806.vue"),
  },
  {
    path: "/news/20250729",
    component: () => import("@/pages/news/details/20250729.vue"),
  },
  {
    path: "/news/20250616",
    component: () => import("@/pages/news/details/20250616.vue"),
  },
  {
    path: "/news/20250521",
    component: () => import("@/pages/news/details/20250521.vue"),
  },
  {
    path: "/news/20250408",
    component: () => import("@/pages/news/details/20250408.vue"),
  },
  {
    path: "/news/20250401",
    component: () => import("@/pages/news/details/20250401.vue"),
  },
  {
    path: "/news/20250325",
    component: () => import("@/pages/news/details/20250325.vue"),
  },
  {
    path: "/",
    redirect: "/home",
  },
];
